import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/s6Config',
    name: 's6Config',
    meta: {
      layout: 'share'
    },
    children: [
      {
        path: 'homePage/:id?',
        name: 's6HomePage',
        component: () => import('@/views/wiki/s6config/homePage/index.vue'),
        meta: {
          title: '【无限轮回】个人信息'
        }
      }
    ]
  }
];

export default routes;
